import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import { Image } from "react-bootstrap";
import { logo } from "../../assets/img";
import { FaHome } from "react-icons/fa";
import { MdWoman2 } from "react-icons/md";
import { MdBlockFlipped } from "react-icons/md";
import { MdApartment } from "react-icons/md";
import { FaBuilding } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import { FaLocationPin } from "react-icons/fa6";
import { LiaCitySolid } from "react-icons/lia";
import { TbWorld } from "react-icons/tb";
import { RiAdminLine } from "react-icons/ri";
import { FaUserCog } from "react-icons/fa";
import { AiOutlineDashboard } from "react-icons/ai";
import { IoIosOptions } from "react-icons/io";
import { FaConciergeBell } from "react-icons/fa";
import { HiMiniWrench } from "react-icons/hi2";
import { FaDoorOpen } from "react-icons/fa";
import { FaCalendarAlt } from "react-icons/fa";
import { FaPersonBooth } from "react-icons/fa";
import { FaDesktop } from "react-icons/fa";
import { FaCoins } from "react-icons/fa";
import { FaBan } from "react-icons/fa";
import { FaCheck } from "react-icons/fa";
import { FaHeadset } from "react-icons/fa";
import { FaHistory } from "react-icons/fa";
import { FaTicketAlt } from "react-icons/fa";
import { FaRetweet } from "react-icons/fa";
import { FaImages } from "react-icons/fa";
import { FaTags } from "react-icons/fa";
import { FaStarHalfAlt } from "react-icons/fa";
import { FaRegFileExcel } from "react-icons/fa";
import { FaStar } from "react-icons/fa";
import { CiBank } from "react-icons/ci";

const SideBar = ({ setSideBarShow, sideBarShow }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");

  const [popup, setPopup] = useState(false);

  const toggle_nav = () => {
    setSideBarShow(!sideBarShow);
  };

  return (
    <div className={`${sideBarShow ? "close_sidebar " : "sidebar  "} `}>
      <header>
        <div
          onClick={() => {
            toggle_nav();
          }}
          className="image_text pointer mt-1"
        >
          {/* {sideBarShow ? (
            <img src={logo} className="nav-close-logo mx-5" alt="" />
          ) : (
            <img src={logo} className="nav-logo mx-5" alt="" />
          )} */}
          {sideBarShow ? (
            <p className="side-bar-title">&nbsp;</p>
          ) : (
            <p className="side-bar-title">Vow Booking</p>
          )}
        </div>
      </header>
      <div className="menu_bar overflow-x-hidden overflow-scroller">
        <div className="menu">
          <ul className="menu_links ps-0">
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/dashboard");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "dashboard" ? " f1 active_bar" : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <AiOutlineDashboard />
                <span className="text text-nowrap trans ps-1">Dashboard</span>
              </h4>
            </li>

            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/roles");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "roles" || splitLocation[1] === "role"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <RiAdminLine />
                <span className="text text-nowrap trans ps-1">Role</span>
              </h4>
            </li>

            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/admins");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "admins" || splitLocation[1] === "admin"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <FaUserCog />
                <span className="text text-nowrap trans ps-1">Admin</span>
              </h4>
            </li>

            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/states");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "states" || splitLocation[1] === "state"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <TbWorld />
                <span className="text text-nowrap trans ps-1">State</span>
              </h4>
            </li>

            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/cities");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "cities" || splitLocation[1] === "city"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <LiaCitySolid />
                <span className="text text-nowrap trans ps-1">Cities</span>
              </h4>
            </li>

            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/locations");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "locations" ||
                  splitLocation[1] === "location"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <FaLocationPin />
                <span className="text text-nowrap trans ps-1">Locations</span>
              </h4>
            </li>

            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/Users");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "Users" || splitLocation[1] === "User"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <FaUsers />
                <span className="text text-nowrap trans ps-1">Users</span>
              </h4>
            </li>

            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/property-request-list");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "property-request-list"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <FaBuilding />
                <span className="text text-nowrap trans ps-1">
                  Property Request
                </span>
              </h4>
            </li>

            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/property-list");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "property-list" ||
                  splitLocation[1] === "property-view"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <MdApartment />
                <span className="text text-nowrap trans ps-1">
                  Property List
                </span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/full-block");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "full-block" ||
                  splitLocation[1] === "full-block"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <MdBlockFlipped />
                <span className="text text-nowrap trans ps-1">Full Block</span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/block");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "block" || splitLocation[1] === "block"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <MdBlockFlipped />
                <span className="text text-nowrap trans ps-1">Block</span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/property-owner-list");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "property-owner-list" ||
                  splitLocation[1] === "property-owner"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <FaHome />
                <span className="text text-nowrap trans ps-1">
                  Property Owner
                </span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/receptionist-list");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "receptionist-list" ||
                  splitLocation[1] === "receptionist"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <MdWoman2 />
                <span className="text text-nowrap trans ps-1">
                  Receptionist
                </span>
              </h4>
            </li>

            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/mcc-list");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "mcc-list" || splitLocation[1] === "mcc"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <IoIosOptions />
                <span className="text text-nowrap trans ps-1">MCC List</span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/recommendation-list");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "recommendation-list" ||
                  splitLocation[1] === "recommendation"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <IoIosOptions />
                <span className="text text-nowrap trans ps-1">
                  Recommendation List
                </span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/subscription-cancel-list");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "subscription-cancel-list" ||
                  splitLocation[1] === "subscription-cancel-list"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <IoIosOptions />
                <span className="text text-nowrap trans ps-1">
                  Subscription Cancel Request
                </span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/property-subscription-cancel-list");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "property-subscription-cancel-list" ||
                  splitLocation[1] === "property-subscription-cancel-list"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <IoIosOptions />
                <span className="text  trans ps-1">
                  Subscription Canceled Properties
                </span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/reccomendation-list");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "reccomendation-list" ||
                  splitLocation[1] === "reccomendation-list"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <FaConciergeBell />
                <span className="text  trans ps-1">Reccomendation Booking</span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/subscribed-property-list");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "subscribed-property-list" ||
                  splitLocation[1] === "subscribed-property-list"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <FaConciergeBell />
                <span className="text  trans ps-1">
                  MMC Subscribe Properties
                </span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/service-list");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "service-list" ||
                  splitLocation[1] === "service"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <HiMiniWrench />
                <span className="text  trans ps-1">Services</span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/hotel-category-list");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "hotel-category-list" ||
                  splitLocation[1] === "hotel-category"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <FaDoorOpen />
                <span className="text  trans ps-1">Hotel Categories</span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/timing-slot-list");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "timing-slot-list" ||
                  splitLocation[1] === "timing-slot"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <FaCalendarAlt />
                <span className="text  trans ps-1">Timing Slot</span>
              </h4>
            </li>

            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/room-category-list");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "room-category-list" ||
                  splitLocation[1] === "room-category-list"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <FaPersonBooth />
                <span className="text  trans ps-1">Room Category</span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/booked-rooms");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "booked-rooms" ||
                  splitLocation[1] === "booked-rooms"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <FaDesktop />
                <span className="text  trans ps-1">Bookings</span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/today-earnings");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "today-earnings" ||
                  splitLocation[1] === "today-earnings-view"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <FaCoins />
                <span className="text  trans ps-1">Today Earnings</span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/cancelled-bookings");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "cancelled-bookings" ||
                  splitLocation[1] === "cancelled-bookings"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <FaBan />
                <span className="text  trans ps-1">Cancelled Bookings</span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/tips-list");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "tips-list" ||
                  splitLocation[1] === "tips-list"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <FaCheck />
                <span className="text  trans ps-1">Tips</span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/user-support-list");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "user-support-list" ||
                  splitLocation[1] === "user-support-list"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <FaHeadset />
                <span className="text  trans ps-1">Users Support</span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/owner-support-list");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "owner-support-list" ||
                  splitLocation[1] === "owner-support-list"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <FaHeadset />
                <span className="text  trans ps-1">Property Owner Support</span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/receptionist-support-list");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "receptionist-support-list" ||
                  splitLocation[1] === "receptionist-support-list"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <FaHeadset />
                <span className="text  trans ps-1">Receptionist Support</span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/transaction-list");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "transaction-list" ||
                  splitLocation[1] === "transaction-list"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <FaHistory />
                <span className="text  trans ps-1">Transaction</span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/coupon-list");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "coupon-list" ||
                  splitLocation[1] === "coupon-list"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <FaTicketAlt />
                <span className="text  trans ps-1">Create Coupons</span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/referral-list");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "referral-list" ||
                  splitLocation[1] === "referral-list-view"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <FaRetweet />
                <span className="text  trans ps-1">Refer & Earn</span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/banner-list");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "banner-list" ||
                  splitLocation[1] === "banner"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <FaImages />
                <span className="text  trans ps-1">Banners</span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/amenity-list");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "amenity-list" ||
                  splitLocation[1] === "amenity"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <FaTags />
                <span className="text  trans ps-1">Amenities</span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/review-list");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "review-list" ||
                  splitLocation[1] === "review"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <FaStarHalfAlt />
                <span className="text  trans ps-1">Reviews</span>
              </h4>
            </li>
            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/report-generator-create");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "report-generator-create" ||
                  splitLocation[1] === "report-generator-create"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <FaRegFileExcel />
                <span className="text  trans ps-1">Reports</span>
              </h4>
            </li>

            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/wishlist");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "wishlist" ||
                  splitLocation[1] === "wishlist-view"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <FaStar />
                <span className="text  trans ps-1">Wishlist</span>
              </h4>
            </li>

            <li
              className="nav_link trans mb-0"
              onClick={() => {
                navigate("/bank-accounts");
              }}
            >
              <h4
                className={` ${
                  splitLocation[1] === "bank-accounts" ||
                  splitLocation[1] === "bank-accounts-view"
                    ? " f1 active_bar"
                    : " "
                }  d-flex ac-js ps-3 gap-1`}
              >
                <CiBank />
                <span className="text  trans ps-1">Bank Account</span>
              </h4>
            </li>
          </ul>
        </div>
      </div>
      {/* <div
        className="d-flex ac-je pt-2 pe-2 pointer logout-btn"
        onClick={() => setPopup(true)}
      >
        {/* <img src={logout} className="icon " alt="" /> 
        {sideBarShow && (
          <h4 className=" f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0">
            Logout
          </h4>
        )}
      </div> */}
    </div>
  );
};

export default SideBar;
